const LinkIcon = ({
  width = 12,
  height = 12,
  strokeColor = 'currentColor',
  strokeWidth = 2
}: {
  width?: number;
  height?: number;
  strokeColor?: string;
  strokeWidth?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      data-target='link'
      className='flex-shrink-0 cursor-pointer'
      fill='none'
      stroke={strokeColor}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
      />
    </svg>
  );
};

export default LinkIcon;
